import { SERVER_MARK_NOTIFICATION_AS_SEEN } from 'constants/ActionTypes';

export const markNotificationAsSeen = notificationId => {
	return {
		type: SERVER_MARK_NOTIFICATION_AS_SEEN,
		payload: { notificationId }
	};
};



// WEBPACK FOOTER //
// ./actions/Notifications.js